import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { Button } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { classNames } from '../../../../utils/common/styling.js';
import { getThemedStyles, styles } from './SidebarCta.styles.js';
import { useCreatorThemeContext } from '../../../../features/Common/modules/Theme/CreatorThemeContext.js';

var SidebarCta = function (_a) {
    var className = _a.className, classes = _a.classes, _b = _a.overrideClasses, overrideClasses = _b === void 0 ? {} : _b, label = _a.label, _c = _a.ctaVariant, ctaVariant = _c === void 0 ? "primary" : _c, restButtonProps = __rest(_a, ["className", "classes", "overrideClasses", "label", "ctaVariant"]);
    var _d = classes || {}, root = _d.root, startIcon = _d.startIcon;
    var theme = useCreatorThemeContext();
    var themedStyles = getThemedStyles({ theme: theme });
    var ctaClasses = {
        primary: {
            root: themedStyles.root,
            startIcon: themedStyles.startIcon,
        },
        secondary: {
            root: styles.secondaryRoot,
            startIcon: overrideClasses.secondaryStartIcon || styles.secondaryStartIcon,
        },
    };
    return (React.createElement("div", { className: classNames(styles.wrapperRoot, className) },
        React.createElement(Button, __assign({ classes: {
                root: classNames(styles.baseRoot, ctaClasses[ctaVariant].root, root),
                startIcon: classNames(styles.baseStartIcon, ctaClasses[ctaVariant].startIcon, startIcon),
            }, startIcon: React.createElement(AddRoundedIcon, null) }, restButtonProps), label)));
};

export { SidebarCta as default };
//# sourceMappingURL=SidebarCta.js.map
